import React, { useState } from 'react';

interface AboutLayerProps {
  children: React.ReactNode;
}

/**
 * Click-to-expand "About this layer" panel for layer-specific educational
 * context. Default collapsed so it stays discoverable without bloating the
 * panel for return users who already understand the layer.
 */
export const AboutLayer: React.FC<AboutLayerProps> = ({ children }) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="border border-figma-lime/20 rounded-figma-panel overflow-hidden">
      <button
        onClick={() => setIsOpen(!isOpen)}
        aria-expanded={isOpen}
        className="w-full flex items-center justify-between px-4 py-2.5 hover:bg-figma-card/50 transition-colors text-left"
      >
        <span className="flex items-center gap-2">
          <svg className="w-4 h-4 text-figma-lime flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
            <path strokeLinecap="round" strokeLinejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-sm font-roboto font-semibold text-figma-lime">
            About this layer
          </span>
        </span>
        <svg
          className={`w-4 h-4 text-figma-lime transition-transform ${isOpen ? 'rotate-180' : ''}`}
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      {isOpen && (
        <div className="px-4 pb-4 pt-1 text-sm font-roboto text-neutral-300 leading-relaxed space-y-2 border-t border-figma-lime/10">
          {children}
        </div>
      )}
    </div>
  );
};
